import { setAdminBreadCrumb } from "@/src/routes/admin-routes.js";
import { PermissionNames } from "@/src/enums";
import FinalizedOfferCSVBatchesIndex from '@/src/components/admin-area/unos/finalized-offers-csv-batches/FinalizedOfferCSVBatchesIndex.vue';
import FinalizedOfferCSVBatchesNew from '@/src/components/admin-area/unos/finalized-offers-csv-batches/FinalizedOfferCSVBatchesNew.vue';
import FinalizedOfferCSVBatchesEdit from '@/src/components/admin-area/unos/finalized-offers-csv-batches/FinalizedOfferCSVBatchesEdit.vue';
import MaskCSVZipIndex from "@/src/components/admin-area/unos/mask-csv-zip/MaskCSVZipIndex.vue";
import MaskCSVZipNew from "@/src/components/admin-area/unos/mask-csv-zip/MaskCSVZipNew.vue";
import MaskCSVZipEdit from "@/src/components/admin-area/unos/mask-csv-zip/MaskCSVZipEdit.vue";

export const adminFinalizedOffersCSVRoutes = [
  {
    path: 'finalized-offers-csv-batches',
    children: [
      {
        path: '',
        name: 'admin_unos_finalized_offers_csv_batch',
        component: FinalizedOfferCSVBatchesIndex,
        beforeEnter: [setAdminBreadCrumb],
        meta: {
          permissions: [PermissionNames.ADMIN_UNOS_FINALIZED_OFFERS_CSV_BATCH]
        }
      },
      {
        path: 'new',
        name: 'admin_unos_finalized_offers_csv_batch_new',
        component: FinalizedOfferCSVBatchesNew,
        beforeEnter: [setAdminBreadCrumb],
        meta: {
          permissions: [PermissionNames.ADMIN_UNOS_FINALIZED_OFFERS_CSV_BATCH]
        }
      },
      {
        path: ':id',
        name: 'admin_unos_finalized_offers_csv_batch_show',
        component: FinalizedOfferCSVBatchesEdit,
        beforeEnter: [setAdminBreadCrumb],
        meta: {
          permissions: [PermissionNames.ADMIN_UNOS_FINALIZED_OFFERS_CSV_BATCH]
        }
      }
    ],
  },
  {
    path: 'unos-mask-csv-zips',
    children: [
      {
        path: '',
        name: 'admin_unos_mask_csv',
        component: MaskCSVZipIndex,
        beforeEnter: [setAdminBreadCrumb],
        meta: {
          permissions: [PermissionNames.ADMIN_UNOS_MASK_CSV]
        }
      },
      {
        path: 'new',
        name: 'admin_unos_mask_csv_new',
        component: MaskCSVZipNew,
        beforeEnter: [setAdminBreadCrumb],
        meta: {
          permissions: [PermissionNames.ADMIN_UNOS_MASK_CSV]
        }
      },
      {
        path: ':id',
        name: 'admin_unos_mask_csv_show',
        component: MaskCSVZipEdit,
        beforeEnter: [setAdminBreadCrumb],
        meta: {
          permissions: [PermissionNames.ADMIN_UNOS_MASK_CSV]
        }
      }
    ]
  }
]